"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Notification_1 = require("./Notification");
var theme = require("./theme.scss");
var mobx_react_1 = require("mobx-react");
var ui_1 = require("@vidazoo/ui");
var NotificationPanel = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationPanel, _super);
    function NotificationPanel(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.markAllAsRead = function () {
            var _a = _this.props, userNotificationsStore = _a.userNotificationsStore, userId = _a.userId;
            userNotificationsStore.markAllAsRead(userId);
        };
        _this.onViewAllClick = function () {
            var history = _this.props.history;
            history.push("/notification-center");
        };
        _this.onSettingsClick = function () {
            var history = _this.props.history;
            history.push("/notification-settings");
        };
        return _this;
    }
    NotificationPanel.prototype.componentDidMount = function () {
        var _a = this.props, userNotificationsStore = _a.userNotificationsStore, userId = _a.userId;
        return userNotificationsStore.initialize(userId);
    };
    NotificationPanel.prototype.renderNoNotificationMessage = function () {
        return (React.createElement("div", { className: theme.notification },
            React.createElement("div", { className: theme.icon },
                React.createElement(ui_1.Icon, { iconName: "icon-rejected-status", iconColor: "var(--label-color)", size: 4 })),
            React.createElement("div", { className: theme.text },
                React.createElement("div", { className: theme.subjectContainer },
                    React.createElement("div", { className: theme.subject }, "No notifications found")),
                React.createElement("div", { className: theme.message }, "We are sorry for the inconvenience"))));
    };
    NotificationPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props.userNotificationsStore, items = _a.items, unseenCount = _a.unseenCount, onSelectItem = _a.onSelectItem;
        return (React.createElement(ui_1.MainMenu, { badgeColor: "red", badgeLabel: unseenCount ? (unseenCount).toString() : null, iconSize: 2.5, iconName: "icon-publishers", stickTo: "right" },
            React.createElement("li", { className: theme.container },
                React.createElement("div", { className: theme.header },
                    React.createElement("div", { className: theme.leftHeader },
                        React.createElement("div", { className: theme.pendingNotifications, onClick: this.onViewAllClick },
                            React.createElement("div", { className: theme.counterLabel }, unseenCount),
                            React.createElement("div", { className: theme.pendingLabel }, "pending notifications")),
                        React.createElement("div", { className: theme.settings, onClick: this.onSettingsClick }, "Settings")),
                    React.createElement("div", { className: theme.rightHeader },
                        React.createElement("div", { className: theme.markAllAsRead, onClick: this.markAllAsRead }, "Mark All as Read"))),
                React.createElement("div", { className: theme.inner },
                    React.createElement("div", { className: theme.notifications }, items.length ? items.map(function (notification) { return (React.createElement(Notification_1.default, { key: notification._id, notification: notification, onSelectItem: onSelectItem, history: _this.props.history })); }) :
                        this.renderNoNotificationMessage())))));
    };
    NotificationPanel.defaultProps = {};
    NotificationPanel = tslib_1.__decorate([
        mobx_react_1.observer
    ], NotificationPanel);
    return NotificationPanel;
}(React.Component));
exports.default = NotificationPanel;
